<script setup>
import { ref } from 'vue';
import Icon from 'next/icon/Icon.vue';
import FormattedContent from './Text/FormattedContent.vue';

defineProps({
  content: {
    type: String,
    required: true,
  },
});

const isExpanded = ref(false);
</script>

<template>
  <div class="mt-2" @click.stop>
    <button
      class="flex items-center gap-1 p-0 border-0 bg-transparent text-xs text-n-slate-11 hover:text-n-slate-12 font-medium"
      @click="isExpanded = !isExpanded"
    >
      <Icon
        :icon="isExpanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        class="size-3"
      />
      {{
        isExpanded
          ? $t('CONVERSATION.HIDE_TRANSCRIPTION')
          : $t('CONVERSATION.SHOW_TRANSCRIPTION')
      }}
    </button>
    <div v-if="isExpanded" class="mt-1 text-sm text-n-slate-12">
      <FormattedContent :content="content" />
    </div>
  </div>
</template>
